// This file is automatically generated from ingestAssets.mjs
import * as React from 'react';
import IconContainer, { IconProps } from '../../../components/IconContainer';

export function ShoppingCartIcon(props: IconProps) {
	return (
		<IconContainer {...props}>
			{
				<svg
					xmlns="http://www.w3.org/2000/svg"
					width="100%"
					height="100%"
					fill="none"
					viewBox="0 0 32 32"
				>
					<path
						fill="currentColor"
						d="M27.767 7.359A1 1 0 0 0 27 7H6.835l-.611-3.357A2 2 0 0 0 4.256 2H2a1 1 0 0 0 0 2h2.25l3.195 17.536a3 3 0 0 0 .666 1.409A3.5 3.5 0 1 0 13.661 24h5.678a3.5 3.5 0 1 0 3.161-2H10.396a1 1 0 0 1-.984-.821L9.016 19h14.5a3 3 0 0 0 2.952-2.464l1.52-8.357a1 1 0 0 0-.22-.82ZM12 25.5a1.5 1.5 0 1 1-3 0 1.5 1.5 0 0 1 3 0Zm12 0a1.5 1.5 0 1 1-3 0 1.5 1.5 0 0 1 3 0Zm.5-9.321a1 1 0 0 1-.988.821H8.652L7.2 9H25.8L24.5 16.179Z"
					/>
				</svg>
			}
		</IconContainer>
	);
}
